<template>
  <div id="dosageChart">
  </div>
</template>
<script>

export default {
  props: ['dateHistory', 'dataHistory', 'title'],
  name: "Dosage-Echarts",
  mounted() {
    this.initEcharts()
  },
  watch: {
    dateHistory: function () {
      this.initEcharts()
    },
    title : function (){
      this.initEcharts()
    }
  },
  methods: {
    initEcharts() {
      let echarts = require('echarts')
      // 基于准备好的dom，初始化echarts实例
      let myChart = echarts.init(document.getElementById('dosageChart'), null, {
        height: 400
      });
      // 绘制图表
      myChart.setOption({
        title: {
          text: this.title
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {},
            magicType: {
              type: ['line', 'bar']
            }
          }
        },
        xAxis: [
          {
            type: 'category',
            data: this.dateHistory,
            axisTick: {
              alignWithLabel: true
            }
          }
        ],
        yAxis: [
          {
            type: 'value',
            axisLabel: {
              formatter: '{value} 吨'
            }
          }
        ],
        series: [
          {
            name: '用水量',
            type: 'bar',
            barWidth: '60%',
            data: this.dataHistory
          }
        ]
      });
    },
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Dosage-ECharts.vue